// extracted by mini-css-extract-plugin
export default {"marginRight":"styles_marginRight__ZtLOy"};